import React from 'react'
import DosageModal from '../../../../Inventory/EditInventory/components/Target/DosageModal';
import { useParams } from 'react-router-dom';
import { targetCropConcernThunk } from '../../../../../store/thunks/InventoryThunk';
import { useDispatch } from 'react-redux';

const CropTab = ({ name, detail }) => {
    const {id} = useParams();
    const dispatch = useDispatch();
    return (
        <div className="custom-radio-button-black">
            {detail?.targetCrops?.[name]?.map(
                (annual_crops, index) => {
                    return (
                        <>
                            <label
                                key={index.toString()}
                                className="status"
                                data-toggle="modal"
                                data-target={`#annual_modal_${annual_crops?.id}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    dispatch(targetCropConcernThunk({
                                            productId: id,
                                            cropId: annual_crops?.id,
                                        })
                                    );
                                }}
                            >
                                <input
                                    type="radio"
                                    name="radio"
                                />
                                <div className="box">
                                    <span>
                                        {annual_crops?.name?.en}
                                    </span>
                                </div>
                            </label>
                            {/*Usage & Dosage Modal Start*/}
                            <DosageModal cropName={annual_crops?.name?.en} modalId={`annual_modal_${annual_crops?.id}`} />
                            {/*Usage & Dosage Modal End*/}
                        </>
                    );
                }
            )}
        </div>
    )
}

export default CropTab